import { CSSProperties, FC } from "react"

export interface LoyaltyProgramRulesListIds {
  rule1: string
  rule2: string
  rule3: string
  rule4: string
  rule5: string
  rule6: string
  closing: string
}

/** DOM ids for RulesModal and NotifyModal (вкладка «Правила сервиса») — совпадают с таймлайном Animator в RulesModal */
export const LOYALTY_RULES_LIST_IDS_RULES_MODAL: LoyaltyProgramRulesListIds = {
  rule1: "rrxrule1",
  rule2: "rrxrule2",
  rule3: "rrrule4",
  rule4: "rrrule5",
  rule5: "rrrule7",
  rule6: "rrrule8",
  closing: "rrrule9",
}

/** DOM ids для HelloModal — совпадают с таймлайном Animator */
export const LOYALTY_RULES_LIST_IDS_HELLO_MODAL: LoyaltyProgramRulesListIds = {
  rule1: "xrule1",
  rule2: "xrule2",
  rule3: "rule4",
  rule4: "rule5",
  rule5: "rule7",
  rule6: "rule8",
  closing: "rule9",
}

export const loyaltyRulesAnimatedItemStyle: CSSProperties = {
  opacity: "0",
  left: "-200px",
}

interface LoyaltyProgramRulesListProps {
  ids: LoyaltyProgramRulesListIds
  /** Пустой объект — без начальных стилей анимации (как во вкладке уведомлений) */
  itemStyle?: CSSProperties
  ulStyle?: CSSProperties
}

const defaultUlStyle: CSSProperties = { marginTop: "0px" }

export const LoyaltyProgramRulesList: FC<LoyaltyProgramRulesListProps> = ({
  ids,
  itemStyle = {},
  ulStyle,
}) => (
  <ul style={{ ...defaultUlStyle, ...ulStyle }}>
    <li id={ids.rule1} style={itemStyle}>
      <b>1. Начисления и использование</b>
      <br />
      После регистрации в системе накоплений <strong>«ТВОЙПЛЮС»</strong> стоимость всех последующих услуг в филиалах партнеров возвращается на ваш накопительный счет в рублях. Эти средства можно потратить в барбершопе на покупку косметики и интернет-магазине программы лояльности <b>ПЛЮС.</b>
    </li>
    <li id={ids.rule2} style={itemStyle}>
      <b>2. География действия</b>
      <br />
      Начисления доступны в филиалах партнеров программы на территории РФ
    </li>
    <li id={ids.rule3} style={itemStyle}>
      <b>3. Активация и условия использования счета</b>
      <br />
      Вы можете получать до 50% кешбэка от суммы визита без подписки и использовать его при оплате товаров в магазине.
      <br />
      С подпиской вы можете получать до 100% кешбэка благодаря статусам.
      <br />
      Начисление кешбэка за услуги происходит на следующий день после посещения.
    </li>
    <li id={ids.rule4} style={itemStyle}>
      <b>4. Система скидок</b>
      <br />
      Изначальная скидка в магазине составляет 10%.
      <br />
      С каждым повышением статуса скидка увеличивается на 5%, достигая максимума — 50% при статусе БРИЛЛИАНТ.
      <br />
      Если подписка не продлена, накопленный уровень скидки сбрасывается до 25%.
    </li>
    <li id={ids.rule5} style={itemStyle}>
      <b>5. Отмена и возврат подписки</b>
      <br />
      Подписка не подлежит возврату.
      <br />
      Покупая подписку, вы соглашаетесь с условиями оферты и сразу же получаете преимущества, некоторые из которых имеют разовый характер.
    </li>
    <li id={ids.rule6} style={itemStyle}>
      <b>6. Безопасность и нарушения</b>
      <br />
      Если вы обнаружили уязвимость или способ обхода системы, просьба незамедлительно сообщить об этом.
      <br />
      В случае выявления нарушений аккаунт может быть заблокирован без возможности восстановления.
    </li>
    <li id={ids.closing} style={itemStyle}>
      <b>Будьте внимательны и наслаждайтесь преимуществами ПЛЮС!</b>
    </li>
  </ul>
)
